import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ExploraLanding from "./pages/ExploraLanding";
import AdminPage from "./pages/AdminPage";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ExploraLanding />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/manage-inquiries" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
